import { IClientsState, initialClientsState } from "./clients/clients.state";
import { ICompanyLogoState, initialCompanyLogoState } from "./companyLogo/companyLogo.state";
import { IContractsState, initialContractsState } from "./contracts/contracts.state";
import { initialTaricCodesState, ITaricCodesState } from "./taricCodes/taricCodes.state";
import { initialTeamsState, ITeamsState } from "./teams/teams.state";
import { initialUsersState, IUsersState } from "./users/users.state";
import { initialCaensState, ICaensState } from "./caens/caens.state";
import { IIbanRegionsState, initialIbanRegionsState } from "./ibanRegions/ibanRegions.state";
import { IArticlesState, initialArticlesState } from "./articles/articles.state";
import { IPermissionsState, initialPermissionsState } from "./permissions/permissions.state";
import { IParnersState, initialParnersState } from "./parners/parners.state";
import { IAppendixesState, initialAppendixesState } from "./appendix/appendix.state";
import { ILocationsState, initialLocationsState } from "./locations/locations.state";
import { initialUnitCodesState, IUnitCodesState } from "./unitCodes/unitCodes.state";
import { initialGroupsArticlesState, IGroupsArticlesState } from "./groupsArticles/groupsArticles.state";
import { IGestiuniState, initialGestiuniState } from "./gestiuni/gestiuni.state";
import { initialVatsState, IVatsState } from "./vats/vats.state";
import { ICostCentersState, initialCostCentersState } from "./costCenters/costCenters.state";
import {IEmployeesState, initialEmployeesState} from "./employees/employees.state";
import { ICompanyUsersState, initialCompanyUsersState } from "./company-users/company-users.state";

export enum AppFeatures {
  TEAMS = 'teams',
  USERS = 'users',
  COMPANY_USERS = 'company-users',
  ARTICLES = 'articles',
  CAENS  = 'caens',
  COMPANY_LOGO = 'companyLogo',
  TARIC_CODES = 'taricCodes',
  CLIENTS = 'clients',
  CONTRACTS = 'contracts',
  PERMISSIONS = 'permissions',
  USER_PERMISSIONS = 'userPermissions',
  LOGGED_USER_PERMISSIONS = 'loggedUserPermissions',
  IBAN_REGIONS = 'ibanRegions',
  USERS_FOR_CLIENT_FILTER = 'usersForClientFilter',
  PARNERS = 'parners',
  APPENDIXES = 'appendixes',
  APPENDIX_TYPES = 'appendixTypes',
  LOCATIONS = 'locations',
  UNIT_CODES = 'unitCodes',
  GROUPS_ARTICLES = 'groupsArticles',
  GESTIUNI = 'gestiuni',
  EMPLOYEES = 'employees',
  VATS = 'vats',
  COST_CENTERS = 'costCenters',
}

export const initialAppState = {
  [AppFeatures.TEAMS]: initialTeamsState,
  [AppFeatures.USERS]: initialUsersState,
  [AppFeatures.COMPANY_USERS]: initialCompanyUsersState,
  [AppFeatures.ARTICLES]: initialArticlesState,
  [AppFeatures.COMPANY_LOGO]: initialCompanyLogoState,
  [AppFeatures.TARIC_CODES]: initialTaricCodesState,
  [AppFeatures.CLIENTS]: initialClientsState,
  [AppFeatures.CONTRACTS]: initialContractsState,
  [AppFeatures.PERMISSIONS]: initialPermissionsState,
  [AppFeatures.USER_PERMISSIONS]: initialPermissionsState,
  [AppFeatures.LOGGED_USER_PERMISSIONS]: initialPermissionsState,
  [AppFeatures.CAENS]: initialCaensState,
  [AppFeatures.IBAN_REGIONS]: initialIbanRegionsState,
  [AppFeatures.USERS_FOR_CLIENT_FILTER]: initialUsersState,
  [AppFeatures.PARNERS]: initialParnersState,
  [AppFeatures.APPENDIXES]: initialAppendixesState,
  [AppFeatures.APPENDIX_TYPES]: initialAppendixesState,
  [AppFeatures.LOCATIONS]: initialLocationsState,
  [AppFeatures.UNIT_CODES]: initialUnitCodesState,
  [AppFeatures.GROUPS_ARTICLES]: initialGroupsArticlesState,
  [AppFeatures.GESTIUNI]: initialGestiuniState,
  [AppFeatures.VATS]: initialVatsState,
  [AppFeatures.COST_CENTERS]: initialCostCentersState,
  [AppFeatures.EMPLOYEES]: initialEmployeesState,
};

export type IAppState = Partial<{
  [AppFeatures.TEAMS]: ITeamsState;
  [AppFeatures.USERS]: IUsersState;
  [AppFeatures.COMPANY_USERS]: ICompanyUsersState;
  [AppFeatures.ARTICLES]: IArticlesState;
  [AppFeatures.USERS_FOR_CLIENT_FILTER]: IUsersState;
  [AppFeatures.COMPANY_LOGO]: ICompanyLogoState;
  [AppFeatures.TARIC_CODES]: ITaricCodesState;
  [AppFeatures.CLIENTS]: IClientsState;
  [AppFeatures.CONTRACTS]: IContractsState;
  [AppFeatures.PERMISSIONS]: IPermissionsState;
  [AppFeatures.USER_PERMISSIONS]: IPermissionsState;
  [AppFeatures.LOGGED_USER_PERMISSIONS]: IPermissionsState;
  [AppFeatures.CAENS]: ICaensState;
  [AppFeatures.IBAN_REGIONS]: IIbanRegionsState;
  [AppFeatures.PARNERS]: IParnersState;
  [AppFeatures.APPENDIXES]: IAppendixesState;
  [AppFeatures.APPENDIX_TYPES]: IAppendixesState;
  [AppFeatures.LOCATIONS]: ILocationsState;
  [AppFeatures.UNIT_CODES]: IUnitCodesState;
  [AppFeatures.GROUPS_ARTICLES]: IGroupsArticlesState;
  [AppFeatures.GESTIUNI]: IGestiuniState;
  [AppFeatures.VATS]: IVatsState;
  [AppFeatures.COST_CENTERS]: ICostCentersState;
  [AppFeatures.EMPLOYEES]: IEmployeesState;
}>;

export function getInitialState(): IAppState {
  return initialAppState;
}
